import { useEffect } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Competence } from "../../types";
import { SkillSelect } from "../common/form";

interface Props {
  onSubmit: (formData: any) => void;
  data?: Array<Competence>;
}

const CompetenceFields = ({ onSubmit, data }: Props) => {
  const { register, control, handleSubmit, reset } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "competences",
  });

  useEffect(() => {
    if (data) {
      reset({ competences: data });
    }
  }, [data, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Kompetenz
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Wert
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Aktionen
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {fields.map((item: any, index) => (
                    <tr key={item.skillId}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <Controller
                          control={control}
                          //@ts-ignore
                          name={`competences.${index}.skillId`}
                          render={({ field }) => <SkillSelect {...field} />}
                          rules={{ required: true }}
                          defaultValue={item.skillId}
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="text"
                          // @ts-ignore
                          {...register(`competences.${index}.value`, {
                            required: true,
                          })}
                          defaultValue={item.value}
                          className="mt-1 focus:ring-orange-500 focus:border-orange-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          className="inline-flex items-center"
                          type="button"
                          onClick={() => remove(index)}
                        >
                          <svg
                            className="h-4 w-4 mr-2 text-gray-300"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                          <span className="text-gray text-sm">Löschen</span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td className="px-6 py-4 flex space-x-4" colSpan={3}>
                      <button
                        className="inline-flex items-center"
                        type="button"
                        onClick={() =>
                          append({
                            skill: "",
                            value: 0,
                          })
                        }
                      >
                        <svg
                          className="h-4 w-4 mr-2 text-gray-300"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          />
                        </svg>
                        <span className="text-gray text-sm">Hinzufügen</span>
                      </button>
                      <button
                        type="submit"
                        className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs leading-4 font-medium rounded-md text-white bg-bluesky-500 hover:bg-bluesky-400 focus:outline-none focus:shadow-outline-indigo focus:border-orange-600 active:bg-bluesky-600 transition duration-150 ease-in-out"
                      >
                        <svg
                          className="-ml-1 mr-2 h-5 w-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Speichern
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CompetenceFields;
